import { useEffect, useState } from "react";
import { useApi } from "../../services";
import { IconButton, Menu, MenuItem } from "@mui/material";

export const CadastroIconButton: React.FC<{ onSelect?: (icon: number) => void; }> = ({ onSelect }) => {
  const api = useApi();

  const [selectedIcon, setSelectedIcon] = useState<string>();
  const [icons, setIcons] = useState<{ [key: string]: string; }>({});
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  useEffect(() => {
    api.zas.getCadastroIcons().then((data) => {
      if ("error" in data) return;
      setIcons(data);
    });
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (icon: string) => {
    const val = Number(icon);
    if (onSelect) onSelect(val);
    setSelectedIcon(icon);
    handleClose();
  };

  const open = Boolean(anchorEl);
  return <div>
    <IconButton
      id="basic-button"
      aria-haspopup="true"
      onClick={handleClick}
      aria-expanded={open ? 'true' : undefined}
      aria-controls={open ? 'basic-menu' : undefined}
    >
      {selectedIcon ?
        <img src={icons[selectedIcon]} alt={selectedIcon} style={{
          objectFit: "contain",
          height: `20px`,
          width: `20px`,
        }} /> :
        "Icone"
      }
    </IconButton>
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
    >
      {Object.keys(icons).map((val, i) => {
        return <MenuItem
          key={i}
          onClick={() => handleSelect(val)}>
          <img
            src={icons[val]}
            alt={val}
            style={{
              objectFit: "contain",
              height: `15px`,
              width: `15px`,
            }}
          />
        </MenuItem>;
      })}
    </Menu>
  </div>;
};